module.exports = __webpack_public_path__ + "img/dhfesta_info_0404.40ca9210.png";